import css from './index.module.scss';
import OverView from './components/OverView';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { SwitchTabModule, BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBaseH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

const defaultStyle = {
    background: 'transparent',
    padding: '0',
    margin: 0,
    border: 'none',
    borderRadius: '0',
};

export default function RiverMiniModule({ cssStyle }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu']);
    const imgLocal = getImageLocal(locale, ['au', 'uk', 'cn']);
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const rminImgLocal = getImageLocal(locale, ['cn']);
    const { t } = useLang('riverminiportablepowerstation');
    const webpUrl = '/media/rivermini/h5/';

    const switchTabData = [
        {
            tab: t('river_mini.five_wall_outlet_charging'),
            subTab: '',
            key: 'k1',
            videoUrl: '',
            imgUrl: ['charge.webp', 'charge.jpg'],
            textTitle: t('river_mini.five_wall_outlet_charging_title'),
            textDesc: t('river_mini.five_wall_outlet_charging_des'),
            textSupliment: '',
            showVideo: false,
        },
        {
            tab: t('river_mini.five_solar_charging'),
            subTab: '',
            key: 'k2',
            videoUrl: '',
            imgUrl: [`solar_${imgLocal}.webp`, `solar_${imgLocal}.jpg`],
            textTitle: t('river_mini.five_solar_charging_title'),
            textDesc: t('river_mini.five_solar_charging_des'),
            textSupliment: '',
            showVideo: false,
        },
        {
            tab: t('river_mini.five_car_outlet_charging'),
            subTab: '',
            key: 'k3',
            videoUrl: '',
            imgUrl: ['car.webp', 'car.jpg'],
            textTitle: t('river_mini.five_car_outlet_charging_title'),
            textDesc: t('river_mini.five_car_outlet_charging_des'),
            textSupliment: '',
            showVideo: false,
        },
    ];

    const otherProductData = getDetaileMoreProducts(gloproductlist, ['product_ps_river_river', 'product_ps_river_river_max', 'product_ps_river_river_pro_720']);

    return (
        <div
            className={`${css.animationWrapper} riverMiniModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <BannerModule
                data={[
                    {
                        bgImgs: [`banner_${imgSpec}.webp`, `banner_${imgSpec}.jpg`],
                        title: t('river_mini.title'),
                        des: t('river_mini.subtitle'),
                    },
                ]}
                config={{ theme: '#000', webpUrl }}
            />
            {/* 一图看懂 */}
            <OverView />
            <LineSpace height={0.6} background="transparent" />
            <div className="textImg textImg-center">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        title: t('river_mini.third_title'),
                        synopsis: t('river_mini.third_subtitle'),
                        desc: t('river_mini.third_des'),
                        img_url: [`210wh_${rminImgLocal}.webp`, `210wh_${rminImgLocal}.jpg`],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="textImg textImg1">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'bottom',
                        text: 'left',
                        phraseColor: '#757575',
                        titleFontSize: locale === 'de' ? 0.14 : 0.16,
                        webpUrl,
                    }}
                    data={{
                        title: t('river_mini.four_title'),
                        synopsis: t('river_mini.four_subtitle'),
                        desc: t.rich('river_mini.four_des', {
                            line1: (text: string) => (
                                <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                                    {text}
                                </Link>
                            ),
                        }),
                        noUseHtmlAttr: true,
                        phrase: t('river_mini.four_text'),
                        arr: [
                            {
                                num: 300,
                                eum: t('river_mini.four_unit'),
                                desc: t('river_mini.four_output'),
                            },
                            {
                                num: 600,
                                eum: t('river_mini.four_unit'),
                                desc: t('river_mini.four_xboost'),
                            },
                        ],
                        img_url: ['x-boost.webp', 'x-boost.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <SwitchTabModule data={switchTabData} cssStyle={{ webpUrl }} />
            <LineSpace height={1.2} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', text: 'left', webpUrl }}
                    data={{
                        title: t('river_mini.six_title'),
                        synopsis: t('river_mini.six_subtitle'),
                        desc: t('river_mini.six_des'),
                        img_url: ['chip.webp', 'chip.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <>
                    <LineSpace height={0.3} background="transparent" />
                    <div className="textImg textImg-center">
                        <TextWithImage
                            config={{ isShowVideo: false, position: 'bottom', webpUrl }}
                            data={{
                                title: t('river_mini.seven_title'),
                                synopsis: t('river_mini.seven_subtitle'),
                                desc: t('river_mini.seven_des'),
                                img_url: [`phone_${appImgLocal}.webp`, `phone_${appImgLocal}.jpg`],
                                video_src: '',
                            }}
                        />
                    </div>
                </>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height={1.2} background="transparent" />
            <OtherList data={otherProductData} />
        </div>
    );
}
